import React, { useState } from 'react';
import Dialog from './Dialog';
import DialogTitle from './DialogTitle';
import DialogTile from './DialogTile';
import DialogTilesContainer from './DialogTilesContainer';
import DialogButtonContainer from './DialogButtonContainer';
import DialogButton from './DialogButton';

export default function ChooseBackgroundDialog({ showDialog, onCancel, onDone }) {
  const [selectedBg, setSelectedBg] = useState(null);

  const chooseBgHandler = (e) => {
    const selectedBgClass = e.currentTarget.getAttribute('data-tileclass');
    setSelectedBg(selectedBgClass === selectedBg ? null : selectedBgClass);
  }

  const onDoneHandle = (e) => {
    onDone(selectedBg);
    setSelectedBg(null);
  }

  return (
    <Dialog show={showDialog}>
      <DialogTitle>
        Select a collection
      </DialogTitle>
      <DialogTilesContainer>
        <DialogTile
          selectedBg={selectedBg}
          onClick={chooseBgHandler}
          bgClassName="bg-radial-redblack"
        >
          Radial R&amp;B
          </DialogTile>
        <DialogTile
          selectedBg={selectedBg}
          onClick={chooseBgHandler}
          bgClassName="bg-lines-red"
        >
          Lines
          </DialogTile>
        <DialogTile
          selectedBg={selectedBg}
          onClick={chooseBgHandler}
          bgClassName="bg-yellow-green-zig"
        >
          Zig-zag
          </DialogTile>
        <DialogTile
          selectedBg={selectedBg}
          onClick={chooseBgHandler}
          bgClassName="bg-maddevs"
        >
          Geometry
          </DialogTile>
      </DialogTilesContainer>
      <DialogButtonContainer>
        <DialogButton type="secondary" onClick={onCancel}>Cancel</DialogButton>
        <DialogButton type="primary" disabled={!selectedBg} onClick={onDoneHandle}>Done</DialogButton>
      </DialogButtonContainer>
    </Dialog>
  );
}
